const PROGRESS_STEP = {
    FIND_LISTING: 'findListing',
    VERIFY_CONTACT: 'verifyContact',
    CONVERT_LISTING: 'convertListing',
};

const PROGRESS_STEP_CONFIG = [
    {
        key: PROGRESS_STEP.FIND_LISTING,
        label: 'Find Listings',
    },
    {
        key: PROGRESS_STEP.VERIFY_CONTACT,
        label: 'Verify Contact',
    },
    {
        key: PROGRESS_STEP.CONVERT_LISTING,
        label: 'Transfer to Zillow',
    },
];

const STEP = {
    FIND_LISTING_RESULTS: 'findListingResults',
    FIND_LISTING_SUCCESS: 'findListingSuccess',
    VERIFY_CONTACT_LIST: 'verifyContactList',
    VERIFY_CONTACT_SUCCESS: 'verifyContactSuccess',
    CONVERT_LISTING_INFO: 'convertListingInfo',
};

const DEEP_LINK_STEP = {
    [PROGRESS_STEP.FIND_LISTING]: STEP.FIND_LISTING_RESULTS,
    [STEP.VERIFY_CONTACT_LIST]: STEP.VERIFY_CONTACT_LIST,
    [PROGRESS_STEP.CONVERT_LISTING]: STEP.CONVERT_LISTING_INFO,
};

export {
    PROGRESS_STEP,
    PROGRESS_STEP_CONFIG,
    DEEP_LINK_STEP,
    STEP,
};
